export type LatLng = {lat: number; lng: number}

const EARTH_RADIUS_MILES = 3958.8

export function toRadians(degrees: number): number {
    return (degrees * Math.PI) / 180
}

export function haversineMiles(from: LatLng, to: LatLng): number {
    const deltaLat = toRadians(to.lat - from.lat)
    const deltaLng = toRadians(to.lng - from.lng)
    const haversineTerm =
        Math.sin(deltaLat / 2) ** 2 +
        Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(deltaLng / 2) ** 2
    return 2 * EARTH_RADIUS_MILES * Math.asin(Math.min(1, Math.sqrt(haversineTerm)))
}
